import { SearchTerm } from './SearchTerm';

const AuditOperatorSearch: SearchTerm [] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'ulUsername',
        translationKey: "name"
    }
];

export default AuditOperatorSearch;

